// API related actions
export const FETCHING_REPORT_BO = '@@toyota/FETCHING_REPORT_BO';
export const FETCHED_REPORT_BO = '@@toyota/FETCHED_REPORT_BO';
export const FETCHED_REPORT_BO_FAILED = '@@toyota/FETCHED_REPORT_BO_FAILED';
export const FETCHING_REPORT_BO_EXCEL = '@@toyota/FETCHING_REPORT_BO_EXCEL';
export const FETCHED_REPORT_BO_EXCEL = '@@toyota/FETCHED_REPORT_BO_EXCEL';
export const FETCHED_REPORT_BO_EXCEL_FAILED = '@@toyota/FETCHED_REPORT_BO_EXCEL_FAILED';
export const DELETE_BO_REPORT = '@@toyota/DELETE_BO_REPORT';
export const DELETE_BO_REPORT_URL = '@@toyota/DELETE_BO_REPORT_URL';
export const FETCHING_REPORT_BY_ORDERS_BO = '@@toyota/FETCHING_REPORT_BY_ORDERS_BO';
export const FETCHED_REPORT_BY_ORDERS_BO = '@@toyota/FETCHED_REPORT_BY_ORDERS_BO';
export const FETCHED_REPORT_BY_ORDERS_BO_FAILED = '@@toyota/FETCHED_REPORT_BY_ORDERS_BO_FAILED';
